module.exports = __webpack_public_path__ + "static/img/MPDPImg.f5116a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/MPDPImg.png
// module id = e3+7
// module chunks = 2